const policyTerms = new (class PolicyTerms {
	constructor() {
		/**
		 * @private
		 * @type {{type:string, callback: () => void}[]}
		 */
		this.callbaks = [];
		this.termsUrl = 'https://www.oi.com.br/portal-de-privacidade/';
	}

	/**
	 * @private
	 * @param {PolicyTermsCallbacksType} type
	 */
	execCallbacks(type) {
		this.callbaks.forEach((cb) => {
			try {
				type == cb.type && cb.callback();
			} catch (error) {
				console.log(error);
			}
		});
	}

	getPolicyTermIsAccepted() {
		const cookie = localStorage.getItem('cookies');
		return cookie == 'true';
	}

	setPolicyTermAsAccepted() {
		localStorage.setItem('cookies', true);
		this.execCallbacks('accept');
	}

	/**
	 * @param {PolicyTermsCallbacksType} type
	 * @param {() =>{}} callback
	 */
	on(type, callback) {
		typeof callback == 'function' && this.callbaks.push({type, callback});
	}
})();

/**
 * @typedef {"accept"} PolicyTermsCallbacksType
 */
